import * as TK from 'components/PDP/Details/components/Marketplace/components/MarketplaceProductDetails/translations/marketplace-product-details.locale.constants';

export const marketPlaceDetailsCommonLocale = {
  [TK.MARKETPLACE_SHIPPING]: 'Shipping:',
  [TK.MARKETPLACE_SHIPPING_TIME]: '5-7 days',
};
